import { initGlobe } from "./globe";
import { initInteractions } from "./interactions";

export default function initWorldMap() {
    const roots = document.querySelectorAll('[data-component="world-map"]');
    if (!roots.length) return;

    roots.forEach((root) => {
        let config;
        try {
            config = JSON.parse(root.dataset.config);
        } catch (e) {
            return;
        }

        const svg = root.querySelector("[data-svg]");
        const stage = root.querySelector("[data-stage]");
        if (!svg || !stage) return;

        const { projection, redraw, ready } = initGlobe(svg, config);
        initInteractions(stage, projection, redraw, ready);
    });
}
